<template>
  <div class="page-wrap">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div>
        <h1 class="page-title">Cities List</h1>
        <span class="page-subtitle">Manage cities and their photos</span>
      </div>
    </div>

    <!-- ── Search ── -->
    <div class="filter-panel">
      <div class="filter-panel__row">
        <div class="filter-field filter-field--grow">
          <label class="filter-label">Search</label>
          <div class="input-icon-wrap">
            <i class="fa fa-search input-icon"></i>
            <input
                placeholder="Search by city name..."
                v-model="filters.q"
                class="dd-input dd-input--icon"
                v-on:keyup.enter="loadData"
            />
          </div>
        </div>
        <div class="filter-field filter-field--action">
          <label class="filter-label" style="visibility:hidden">Go</label>
          <button class="btn-filter" @click="loadData">
            <i class="fa fa-search"></i> Filter
          </button>
        </div>
      </div>
    </div>

    <!-- ── Table ── -->
    <div class="table-panel">
      <div class="table-responsive-wrap">
        <table class="dd-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Name</th>
            <th>Country ID</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id" class="dd-table__row">
            <td><span class="order-id">#{{ item.id }}</span></td>
            <td>
              <img v-if="item.photo" :src="item.photo.url" class="city-thumb" :alt="item.name" />
              <span v-else class="city-thumb city-thumb--empty"><i class="fa fa-picture-o"></i></span>
            </td>
            <td><span class="item-title">{{ item.name }}</span></td>
            <td><span class="muted-cell">{{ item.country_id ?? '—' }}</span></td>
            <td>
              <div class="td-actions">
                <button class="btn-icon btn-icon--amber" title="Edit" @click="edit(item)">
                  <i class="fa fa-pencil"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr v-if="items && items.length === 0">
            <td colspan="5" class="empty-state">
              <i class="fa fa-map-marker"></i>
              <div>No cities found</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { config } from "../../helpers";

export default {
  name: "Cities",
  data() {
    return {
      url: "",
      items: [],
      filters: { q: "" },
    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/cities";
    this.loadData();
  },

  methods: {
    loadData() {
      axios
          .get(this.url, { params: { q: this.filters.q || undefined } })
          .then((r) => { this.items = r.data.data; });
    },

    edit(city) {
      // `/cities` has no show endpoint, so carry the name along to re-fetch the
      // city after a page refresh.
      this.$router.push({ path: `/cities/${city.id}`, query: { name: city.name } });
    },
  },
};
</script>

<style scoped>
.page-wrap    { display: flex; flex-direction: column; gap: 16px; }
.page-header  { display: flex; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.page-title   { font-size: 20px; font-weight: 500; color: var(--text-1); margin: 0 0 2px; }
.page-subtitle { font-size: 12px; color: var(--text-3); }

/* Filters */
.filter-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; padding: 14px; }
.filter-panel__row { display: flex; align-items: flex-end; gap: 10px; flex-wrap: wrap; }
.filter-field { display: flex; flex-direction: column; gap: 5px; }
.filter-field--grow   { flex: 1 1 260px; }
.filter-field--action { flex: 0 0 auto; }
.filter-label { font-size: 11px; font-weight: 500; color: var(--text-3); text-transform: uppercase; letter-spacing: .4px; }

.dd-input { height: 36px; background: var(--bg-base); border: 1px solid var(--border); border-radius: 8px; color: var(--text-1); font-size: 13px; padding: 0 10px; outline: none; width: 100%; transition: border-color .15s; }
.dd-input:focus { border-color: var(--accent); }
.dd-input::placeholder { color: var(--text-3); }
.input-icon-wrap { position: relative; }
.input-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--text-3); font-size: 13px; }
.dd-input--icon { padding-left: 32px; }

.btn-filter { height: 36px; padding: 0 16px; background: var(--accent); border: none; border-radius: 8px; color: #fff; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: opacity .15s; }
.btn-filter:hover { opacity: .88; }

/* Table */
.table-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.table-responsive-wrap { overflow-x: auto; }
.dd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dd-table thead tr { border-bottom: 1px solid var(--border); }
.dd-table th { padding: 10px 14px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; color: var(--text-3); text-align: left; white-space: nowrap; }
.dd-table td { padding: 12px 14px; color: var(--text-2); border-bottom: 1px solid var(--border); vertical-align: middle; }
.dd-table__row:hover td { background: var(--bg-hover); }
.dd-table tr:last-child td { border-bottom: none; }

.order-id   { font-weight: 500; color: var(--text-1); }
.item-title { font-weight: 500; color: var(--text-1); }
.muted-cell { font-size: 12px; color: var(--text-3); }

.city-thumb { width: 54px; height: 36px; border-radius: 6px; object-fit: cover; border: 1px solid var(--border); display: block; }
.city-thumb--empty { display: flex; align-items: center; justify-content: center; background: var(--bg-hover); color: var(--text-3); font-size: 14px; }

/* Action buttons */
.td-actions { display: flex; gap: 6px; }
.btn-icon { width: 30px; height: 30px; border-radius: 7px; border: 1px solid var(--border); background: var(--bg-hover); display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 13px; color: var(--text-2); transition: border-color .15s, color .15s, background .15s; }
.btn-icon--amber:hover { border-color: #f59e0b; color: #f59e0b; background: rgba(245,158,11,.08); }

/* Empty */
.empty-state { text-align: center; padding: 3rem 1rem !important; color: var(--text-3); }
.empty-state i { font-size: 32px; display: block; margin-bottom: 8px; }
</style>
